<template>
  <div class="reclamations">
    <Tabs
      @tabActiveUpdate="$_reclamations_updateTab"
      :tabs="tabs"
      :active="tabActive"
      title="Рекламации от дилеров"
      class="tab--table"
    >
      <template v-if="load && statuses.length">
        <Journal
          v-if="tabActive === tabs[0].path"
          @clearParams="$_reclamations_clearParams"
          :optionActions="optionActions"
          :reclamations="dealers"
          :isDealersPage="true"
          :isNoArchive="true"
          :tab="tabActive"
        />
        <Journal
          v-else-if="tabActive === tabs[1].path"
          @clearParams="$_reclamations_clearParams"
          :reclamations="dealersArchived"
          :tab="tabActive"
        />
      </template>
    </Tabs>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import mixinReclamations from '@/mixins/Account/reclamations.mixin';
import { isActionsArchived, isActionsChangeStatus } from '@/utils/reclamation';

export default {
  mixins: [mixinReclamations],

  metaInfo() {
    return {
      title: `Рекламации от дилеров - Личный кабинет дилера - ${this.getDealerName}`,
    };
  },

  computed: {
    ...mapState({
      dealers: (state) => state.account.reclamations.dealers,
      dealersArchived: (state) => state.account.reclamations.dealersArchived,
    }),

    ...mapGetters('user', ['getDealerName', 'getConfigAccess']),

    isArchived() {
      return isActionsArchived({
        isPage: true,
        configAccess: this.getConfigAccess,
      });
    },

    isChangeStatus() {
      return isActionsChangeStatus({
        configAccess: this.getConfigAccess,
      });
    },

    optionActions() {
      const list = [
        this.isArchived && {
          label: 'Перенести в архив',
          value: 'archived',
        },
        this.isChangeStatus && {
          label: 'Изменить статус',
          value: 'changeStatus',
        },
      ].filter(Boolean);

      return list;
    },
  },
};
</script>